import Select, { components } from "react-select";
import styled from "styled-components";

const selectStyles = ({ disabled }) => ({
  placeholder: (provided) => ({
    ...provided,
    fontSize: 13,
    fontWeight: 500,
  }),
  input: (provided) => ({
    ...provided,
    fontSize: 13,
    fontWeight: 500,
    color: "#FFF",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: 13,
    fontWeight: 500,
    color: disabled ? "#777" : "#FFF",
  }),
  control: (provided) => ({
    ...provided,
    color: "#FFF",
    borderColor: "#2d364e",
    fontFamily: "Montserrat",
  }),
  menu: (provided) => ({
    ...provided,
    fontFamily: "Montserrat",
    color: "#FFF",
    fontSize: 13,
    fontWeight: 500,
    padding: "5px 0",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#2684FF" : "#454C63",
    padding: "8px 13px",
    overflow: "hidden",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#2275D7",
    },
    "& + button": {
      background: state.isSelected ? "#2684FF" : "#454C63",
      svg: {
        path: {
          fill: state.isSelected ? "white" : "#1862C7",
        },
      },
    },
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    maxHeight: 118,
    overflow: "hidden",
  }),
});

const CustomOptionContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  overflow: hidden;
  &:hover {
    button {
      background: #2275d7;
      svg {
        path {
          fill: white;
        }
      }
    }
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  right: 0px;
  border: none;
  background-color: #454c63;
  width: 30px;
  height: 100%;
  &:hover {
    background: #ff3d71 !important;
    svg {
      path {
        fill: white;
      }
    }
  }
`;

const Option = (props) => {
  return (
    <CustomOptionContainer>
      <components.Option {...props} />
      <DeleteButton onClick={() => props.onDelete(props.data.presetId)}>
        <svg
          width="12"
          height="18"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.91377 19.4513C1.57167 19.3536 1.52279 19.0603 1.47392 18.7671C1.42505 18.2784 1.37618 17.7896 1.3273 17.3498C1.27843 16.7633 1.22956 16.1769 1.18068 15.5904C1.13181 15.1017 1.08294 14.6129 1.03407 14.1242C0.985194 13.5377 0.936321 12.9513 0.887448 12.3648C0.838576 11.7783 0.789703 11.1918 0.691958 10.5565C0.643085 10.0678 0.594213 9.62791 0.54534 9.13919C0.496467 8.79708 0.496467 8.50384 0.447595 8.16174C0.398722 7.67301 0.594213 7.42864 1.08294 7.42864C2.84235 7.42864 4.60177 7.42864 6.36119 7.42864C6.41006 7.42864 6.41006 7.42864 6.45893 7.42864C6.21457 7.3309 6.01908 7.28203 5.77471 7.18428C4.45515 6.69555 3.08672 6.2557 1.76716 5.76697C1.3273 5.62036 0.838576 5.42487 0.398722 5.27825C0.0566133 5.1805 -0.0900047 4.88727 0.0566133 4.59403C0.349849 3.71432 0.643085 2.83461 0.985194 1.95491C1.08294 1.6128 1.37618 1.51505 1.71828 1.6128C2.84235 2.05265 4.0153 2.44363 5.13937 2.88349C6.75217 3.46996 8.36497 4.05643 10.0266 4.6429C11.1996 5.08276 12.3725 5.47374 13.5455 5.91359C13.9853 6.06021 14.0831 6.40232 13.9364 6.69555C13.5943 7.52639 13.35 8.35722 13.0079 9.23693C12.8612 9.57904 12.6169 9.72566 12.2748 9.57904C11.4439 9.28581 10.662 8.99257 9.83115 8.69933C9.63565 8.65046 9.39129 8.60159 9.1958 8.60159C6.70329 8.60159 4.25966 8.60159 1.76716 8.60159C1.71828 8.60159 1.62054 8.60159 1.52279 8.60159C1.52279 8.79708 1.52279 8.9437 1.57167 9.13919C1.66941 10.2144 1.76716 11.2407 1.8649 12.3159C1.96265 13.2934 2.06039 14.3197 2.15814 15.2971C2.20701 16.0302 2.30476 16.7633 2.35363 17.4964C2.45137 17.6919 2.45137 17.9851 2.50025 18.2784C2.50025 18.3761 2.54912 18.425 2.64686 18.425C4.50402 18.425 6.31231 18.425 8.16948 18.425C8.85369 18.425 9.58678 18.425 10.3199 18.425C10.3687 18.1318 10.3687 17.7896 10.4176 17.4964C10.4665 17.0077 10.5154 16.519 10.5642 16.0302C10.6131 15.5904 10.662 15.1505 10.7109 14.7107C10.7597 14.0753 10.8086 13.4889 10.8575 12.8535C10.9063 12.4137 10.9552 11.9738 11.0041 11.4851C11.053 11.143 11.2973 10.8986 11.5906 10.9475C11.8838 10.9963 12.0793 11.2896 12.0793 11.5828C12.0304 12.1693 11.9815 12.7558 11.9327 13.3422C11.8838 13.9287 11.7861 14.5152 11.7372 15.1505C11.6883 15.737 11.6394 16.3235 11.5906 16.9099C11.5417 17.3987 11.4928 17.8385 11.4439 18.3272C11.4439 18.4739 11.3951 18.6694 11.3951 18.816C11.3951 19.1092 11.2485 19.3536 10.9552 19.4513C7.87624 19.4513 4.89501 19.4513 1.91377 19.4513ZM1.22956 4.44741C1.37618 4.49629 1.52279 4.59403 1.71828 4.6429C2.9401 5.08276 4.11304 5.52261 5.33486 5.91359C6.94766 6.50006 8.56046 7.08654 10.2221 7.62414C10.8086 7.81963 11.4439 8.06399 12.0304 8.25948C12.0793 8.25948 12.177 8.35722 12.2259 8.21061C12.4214 7.72188 12.568 7.18428 12.7635 6.69555C12.7146 6.64668 12.6658 6.64668 12.6658 6.64668C11.3951 6.20683 10.1244 5.76697 8.85369 5.27825C7.19202 4.69178 5.53035 4.1053 3.86868 3.51883C3.23334 3.32334 2.59799 3.12785 2.01152 2.88349C1.8649 2.83461 1.81603 2.88349 1.76716 2.98123C1.57167 3.46996 1.42505 3.95869 1.22956 4.44741Z"
            fill="#1862C7"
          />
          <path
            d="M6.31234 0C6.89881 0.195491 7.48528 0.439854 8.07175 0.635345C9.04921 0.977453 10.0267 1.31956 11.0041 1.71054C11.3462 1.85716 11.444 2.10152 11.3462 2.44363C11.2485 2.78574 11.1019 3.07898 11.0041 3.42109C10.9064 3.66545 10.7109 3.81207 10.4665 3.76319C10.1733 3.71432 10.0267 3.5677 9.97779 3.32334C9.97779 3.27447 9.97779 3.2256 9.97779 3.17672C10.0267 2.98123 10.1244 2.78574 10.1733 2.54138C8.95146 2.10152 7.72964 1.66167 6.45895 1.22182C6.41008 1.41731 6.31234 1.6128 6.26346 1.75942C6.16572 2.00378 5.92136 2.10152 5.72586 2.10152C5.4815 2.05265 5.28601 1.90603 5.28601 1.6128C5.28601 1.51505 5.28601 1.41731 5.33488 1.31956C5.43263 1.02633 5.53037 0.684217 5.67699 0.390981C5.72586 0.244363 5.87248 0.146618 6.0191 0C6.11685 0 6.21459 0 6.31234 0Z"
            fill="#1862C7"
          />
        </svg>
      </DeleteButton>
    </CustomOptionContainer>
  );
};

const CustomSelect = (props) => {
  const { onDeleteOption } = props;
  return (
    <Select
      {...props}
      styles={selectStyles({ disabled: props.isDisabled })}
      components={{
        Option: (props) => <Option {...props} onDelete={onDeleteOption} />,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 5,
        colors: {
          ...theme.colors,
          neutral0: props.background ? props.background : "#2d364e",
          neutral5: props.background ? props.background : "#2d364e",
          primary25: "#2275D7",
        },
      })}
    />
  );
};

export default CustomSelect;
